module.exports = __webpack_public_path__ + "img/demologo.4a44aed5.jpg";